module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338628/introduction01-3345ade2d3a169204b6fd043c3d1709f.png";